/*
Accordion Item
*/

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.details = null;
    this.content = null;
  }

  connectedCallback() {
    this.icon = this.querySelector("svg");
    this.details = this.querySelector("details");
    this.content = this.querySelector(".content");
    this.details.addEventListener("click", (e) => {
      e.preventDefault();
      this.animateHeight();
    });
  }

  animateHeight() {
    if (this.details.open) {
      this.icon.style.transform = "rotate(45deg)";
      this.content.style.maxHeight = "0px";
      setTimeout(() => {
        this.details.open = false;
      }, 300);
    } else {
      this.details.open = true;
      this.icon.style.transform = "rotate(90deg)";
      this.content.style.maxHeight = this.content.scrollHeight + "px";
    }
  }
}

customElements.define("accordion-item", AccordionItem);
